import { API_ROOT } from '../../config/config'
import { doGet } from './utils'

// const API_ROOT = 'http://localhost:80/api'

export const getProjectIndicatorsDetails = (
  searchCode,
  year,
  startDate,
  endDate,
  supTeamLeader,
  supported,
  sector,
  pageSize,
  pageNumber
) => {
  const url = `${API_ROOT}/subproject/project-indicators/linked/${pageSize}/${pageNumber}/${searchCode}?year=${year}&startDate=${startDate}&endDate=${endDate}&supTeamLeader=${supTeamLeader}&supported=${supported}&sector=${sector}`
  return doGet(url)
}

export const getProjectIndicators = () => {
  const url = `${API_ROOT}/subproject/project-indicators/page`
  return doGet(url)
}
